"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importStar(require("swiper"));
require("swiper/css");
require("swiper/css/effect-fade");
const topPage = () => {
    if (!document.body.classList.contains('top'))
        return;
    const isSp = window.matchMedia('(max-width: 750px)').matches;
    const swiperElem = document.querySelector('.swiper');
    const swiperWrapper = document.querySelector('.swiper-wrapper');
    const swiperSlides = document.querySelectorAll('.swiper-slide');
    if (isSp) {
        // SPのみ
        const swiper = new swiper_1.default(".top_section_training_swiper", {
            modules: [swiper_1.EffectFade, swiper_1.Autoplay],
            effect: "fade",
            slidesPerView: 1,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            fadeEffect: {
                crossFade: true
            }
        });
    }
    else {
        // SP以外
        swiperElem.classList.remove('swiper');
        swiperWrapper.classList.remove('swiper-wrapper');
        swiperSlides.forEach((slide) => {
            const slideElem = slide;
            slideElem.classList.remove('swiper-slide');
        });
    }
};
exports.default = topPage;
